import { render, staticRenderFns } from "./PreviousVersion.vue?vue&type=template&id=0ec3e9b6&scoped=true&"
import script from "./PreviousVersion.vue?vue&type=script&lang=js&"
export * from "./PreviousVersion.vue?vue&type=script&lang=js&"
import style0 from "./PreviousVersion.vue?vue&type=style&index=0&id=0ec3e9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec3e9b6",
  null
  
)

export default component.exports